<!-- ALPR media display with flip functionality -->
<div class="alpr-media-card" [class.alpr-media-card--flipped]="isFlipped">
  <!-- Media Preview Side -->
  <div class="alpr-media-card__preview">
    <ng-template [ngIf]="alarm.thumbnailUrl || getAlprContextImage()" [ngIfElse]="emptyState">
      <div class="alpr-media-card__thumbnails">
        <!-- Primary thumbnail - use ALPR context image if available, otherwise regular thumbnailUrl -->
        <div class="alpr-media-card__image-container">
          <img
            class="alpr-media-card__thumbnail"
            [src]="getAlprContextImage() || alarm.thumbnailUrl"
            (error)="onContextImageError()"
          />

          <!-- Bounding box overlay for ALPR images -->
          <div
            class="alpr-media-card__bounding-box"
            *ngIf="hasValidBoundingBoxData()"
            [style]="getBoundingBoxStyling()"
          ></div>
        </div>

        <!-- Enlarge button overlay for LPR images -->
        <div class="alpr-media-card__enlarge-overlay" *ngIf="!hideActions">
          <fs-fullscreen-icon
            matTooltip="{{ 'map.alarmCard.menu.enlargeImage' | t }}"
            (clicked)="openEnlargedImageDialog()"
            class="alpr-media-card__enlarge-btn"
          >
          </fs-fullscreen-icon>
        </div>
      </div>
    </ng-template>

    <ng-template #emptyState>
      <div class="alpr-media-card__empty">
        <sn-icon size="xl">warning</sn-icon>
        <span>{{ 'map.alarmCard.noMediaAvailable' | t }}</span>
      </div>
    </ng-template>
  </div>

  <!-- Details Side (shown when flipped) -->
  <div class="alpr-media-card__details">
    <div class="alpr-media-card__details-content">
      <mat-list interactive="false">
        <!-- Acknowledged by user -->
        <mat-list-item class="alpr-media-card__list-item" *ngIf="alarm.ackedBy">
          <div mat-line>
            <ng-container *ngIf="alarm.ackedBy?.fullName">{{
              alarm.ackedBy.fullName
            }}</ng-container>
          </div>
        </mat-list-item>

        <!-- Dynamic details -->
        <ng-container *ngFor="let item of alarm.details | keyvalue; trackBy: trackDetailItem">
          <ng-container [ngSwitch]="true">
            <!-- Object details -->
            <ng-container *ngSwitchCase="isObject(item.value)">
              <mat-list class="alpr-media-card__details-text">
                <span class="alpr-media-card__layer-key">{{ item.key }}</span>
                <ng-container *ngIf="item.key === 'layerData'">
                  <div
                    *ngFor="let detail of item.value | keyvalue : originalOrder"
                    class="alpr-media-card__wrapper"
                  >
                    <li>
                      <span class="alpr-media-card__detail-key">{{ detail.key }}:</span>
                      {{ detail.value }}
                    </li>
                  </div>
                </ng-container>
              </mat-list>
            </ng-container>

            <!-- Array details -->
            <ng-container *ngSwitchCase="isArray(item.value)">
              <ng-container *ngIf="item?.value?.length">
                <mat-list>
                  <span class="alpr-media-card__detail-key">{{ item.key }}</span>
                  <ng-container *ngIf="item.key === 'Plate Analytics'; else recursiveTmpl">
                    <ng-container *ngFor="let detail of formatDataKeys(item.value)">
                      <mat-list-item>
                        <div mat-line>
                          <div class="alpr-media-card__detail-key" mat-line>{{ detail.key }}:</div>
                          {{ detail.value }}
                        </div>
                      </mat-list-item>
                    </ng-container>
                  </ng-container>
                </mat-list>
              </ng-container>
            </ng-container>

            <!-- Standard details -->
            <ng-container *ngSwitchDefault>
              <mat-list-item
                class="alpr-media-card__details-text"
                *ngIf="canSeeDetail(alarm.type, item.key)"
              >
                <div mat-line>
                  <div class="alpr-media-card__detail-key" mat-line>{{ item.key }}:</div>
                  <ng-container [ngSwitch]="true">
                    <ng-container *ngSwitchCase="isTimestamp(item.value)">
                      {{ item.value | date : ('alpr.dateFormats.shortDateTime' | t) }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      {{ item.value }}
                    </ng-container>
                  </ng-container>
                </div>
              </mat-list-item>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- ALPR-specific details -->
        <ng-container *ngIf="alarm.type.toLowerCase().indexOf('alpr') > -1">
          <fs-alpr-details [alarm]="alarm"></fs-alpr-details>
        </ng-container>
      </mat-list>
    </div>
  </div>
</div>

<!-- Recursive template for nested objects -->
<ng-template #recursiveTmpl>
  <ng-container *ngFor="let subItem of item.value; trackBy: trackDetailItem">
    <ng-container [ngSwitch]="true">
      <ng-container *ngSwitchCase="isObject(subItem.value)">
        <ul class="alpr-media-card__nested-list">
          <span class="alpr-media-card__layer-key">{{ subItem.key }}</span>
          <ng-container *ngFor="let subItem2 of subItem.value | keyvalue">
            <div
              class="alpr-media-card__nested-item"
              *ngIf="canSeeDetail(alarm.type, subItem2.key)"
            >
              <li class="alpr-media-card__details-text">
                <span class="alpr-media-card__detail-key">{{ subItem2.key }}:</span>
                {{ subItem2.value }}
              </li>
            </div>
          </ng-container>
        </ul>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
